import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-header',
  templateUrl: './app-sidebar-header.component.html'
})
export class AppSidebarHeaderComponent { }



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-header/app-sidebar-header.component.ts